module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page",
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "id": _vm.pageContainerId,
      "data-loaded": "false",
      "data-page-number": "pageNumber"
    }
  }, [_c('div', {
    staticClass: "canvasWrapper"
  }, [_c('canvas', {
    attrs: {
      "id": ("page" + _vm.pageNumber),
      "height": _vm.pageHeight,
      "width": _vm.pageWidth
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textLayer"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f53f8b6e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print/pdf-page.vue
// module id = 1294
// module chunks = 21